@if (lead && enabled) {
  <button
    class="transparent-btn"
    (click)="addProposalModal.openModal()"
    ngbTooltip="Ajouter les offres"
    i18n-ngbTooltip
  >
    <app-arrow-right-icon height="16px" width="16px" color="var(--brand-500)" />
  </button>
  <app-add-proposal-modal
    #addProposalModal
    [leadId]="lead.leadId"
    [disableNavigation]="true"
    (proposalAdded)="refreshTaskDetails()"
    [preload]="false"
  />
}
